"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputEntityReference = exports.InputEntityReference = exports.InputEntityReferenceComponent = exports.InputEntityReferenceDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var lodash_1 = require("lodash");
var theme_1 = require("@shapeable/theme");
var to_array_1 = require("../../utils/to-array");
var use_lang_1 = require("../../hooks/use-lang");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var field_container_1 = require("../elements/field-container");
var client_1 = require("@apollo/client");
var entity_search_select_1 = require("../entities/entity-search-select");
var menu_context_1 = require("../context/menu-context");
exports.InputEntityReferenceDefaultProps = {
  loading: false,
  isClearable: true,
  isMulti: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EntitySelectStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Functions -------->
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Select: (0, styled_components_1.default)(entity_search_select_1.EntitySearchSelect)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), EntitySelectStyles)
};
var InputEntityReferenceComponent = function (props) {
  var className = props.className,
    field = props.field,
    isMulti = props.isMulti,
    isClearable = props.isClearable,
    onChange = props.onChange,
    context = props.context,
    variant = props.variant,
    loadOptionsFilter = props.loadOptionsFilter;
  if (!field) {
    throw new Error('InputSelect requires a field specification.');
  }
  var name = field.name,
    valid = field.valid,
    focus = field.focus;
  var t = (0, use_lang_1.useLang)();
  var fieldState = context.fieldState,
    _a = context.entityData,
    entityData = _a === void 0 ? {
      name: ''
    } : _a;
  var parentConfig = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(context.entityTypeName);
  // console.log("FIELD.VALUE", field.value);
  // console.log("FIELD.METADATA", field.metadata);
  var metadata = __assign(__assign({}, field.metadata || {}), {
    parent: {
      type: parentConfig.label,
      name: fieldState && fieldState.name && fieldState.name.value
    }
  });
  var multiValue = (0, to_array_1.toArray)(field.value);
  var initialOptions = (0, lodash_1.filter)(__spreadArray(__spreadArray([], __read(metadata.cacheOptions || []), false), __read(field.name && (0, to_array_1.toArray)(entityData[field.name]).map(function (item) {
    return __assign(__assign({}, item), {
      value: item.id
    });
  }) || []), false));
  // console.log("INITIAL OPTIONS", initialOptions);
  var ref = React.useRef();
  var transformId = function (id) {
    if (!id) {
      return null;
    }
    var item = initialOptions.find(function (option) {
      return "".concat((0, lodash_1.get)(option, 'entity.__typename'), ":").concat((0, lodash_1.get)(option, 'entity.id')) === id;
    }) || {};
    return {
      value: (0, lodash_1.get)(item, 'entity.id', ''),
      label: (0, lodash_1.get)(item, 'entity.name', ''),
      entity: item.entity
    };
  };
  var optionValue = isMulti ? (0, lodash_1.filter)(multiValue.map(transformId)) : transformId(field.value);
  var _b = __read(React.useState(optionValue), 2),
    value = _b[0],
    setValue = _b[1];
  // console.log("VALUE IS", value);
  // this is a workaround for problems with rendering up the chain, which would require a full rewrite of the forms code.
  React.useEffect(function () {
    setValue(optionValue);
  }, [entityData]);
  var valueForOption = function (option) {
    return option ? "".concat((0, lodash_1.get)(option, 'entity.__typename'), ":").concat((0, lodash_1.get)(option, 'value')) : null;
  };
  var client = (0, client_1.useApolloClient)();
  var handleChange = function (info) {
    var newValue = isMulti ? (info || []).map(valueForOption) : valueForOption(info);
    var cacheOptions = field.metadata && field.metadata.cacheOptions || [];
    var newCacheOptions = (0, lodash_1.uniqBy)(__spreadArray(__spreadArray([], __read(cacheOptions), false), __read((0, to_array_1.toArray)(info)), false), function (option) {
      return option.value;
    });
    onChange({
      name: field.name,
      client: client,
      value: newValue,
      metadata: {
        cacheOptions: newCacheOptions
      }
    });
    // console.log("SELECT ONCHANGE INFO VALUE", info);
    // console.log("NEW VALUE", newValue);
    setValue(info);
  };
  return React.createElement(My.Container, {
    field: field,
    className: className
  }, React.createElement(menu_context_1.MenuProvider, {
    value: {
      portal: ref,
      preventDelete: true
    }
  }, React.createElement("div", {
    ref: ref
  }, React.createElement(My.Select, {
    isSearchable: true,
    isClearable: true,
    onChange: handleChange,
    value: value,
    isMulti: isMulti
  }))));
};
exports.InputEntityReferenceComponent = InputEntityReferenceComponent;
exports.InputEntityReferenceComponent.defaultProps = exports.InputEntityReferenceDefaultProps;
exports.InputEntityReference = (0, styled_components_1.withTheme)(exports.InputEntityReferenceComponent);
var createInputEntityReference = function (props) {
  return React.createElement(exports.InputEntityReference, __assign({}, props));
};
exports.createInputEntityReference = createInputEntityReference;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;